import { AfterViewInit, Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  Validators,
  FormsModule,
} from '@angular/forms';
import { AuthService } from '../services/auth/auth.service';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import { ToastService } from '../toast/toast.service';
import { CaptchaService } from '../services/captcha.service';
import { CookieService } from 'ngx-cookie-service';
import * as CryptoJS from 'crypto-js';
import { SweetAlertService } from '../toast/sweet-alert.service';
import { TRANSLATIONS_EN } from '../i18n/translations.en';
import { TRANSLATIONS_HI } from '../i18n/translations.hi';

import { NgxUiLoaderService } from 'ngx-ui-loader';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit, AfterViewInit {
  loginForm: FormGroup;
  isSubmit: Boolean = false;
  captchaQuestion: string = '';
  correctAnswer: number = 0;
  userCaptchaInput: number = 0;

  // correctAnswer: string = '';
  // userCaptchaInput: string | null = null;
  errorMessage: string = '';
  currentYear: any;
  constructor(
    private toastService: ToastService,
    private fb: FormBuilder,
    private alertService: SweetAlertService,
    private ngxUiLoaderService: NgxUiLoaderService,
    private authService: AuthService,
    private router: Router,
    private captchaService: CaptchaService,
    private cookieService: CookieService
  ) {
    // Initialize the form group
    this.loginForm = this.fb.group({
      UserId: ['', Validators.required],
      Password: [''],
      rememberMe: [''],
    });

    let email = this.getEmailFromCookie();
    if (email) {
      let password = this.getDecryptedCookie('userkey', email);
      this.loginForm.patchValue({
        UserId: email,
        Password: password,
      });
    }
  }
  ngAfterViewInit(): void {

  }
  ngOnInit(): void {
    this.generateNewCaptcha();
    this.currentYear = new Date().getFullYear();

  }
  currentLocation: any;

  roleList: any;
  showRoleSelector: any;
   onSubmit() {
    this.isSubmit = true;

    if (this.loginForm.invalid) return;

    if (this.loginForm.controls['rememberMe'].value) {
      this.saveUserIdInCookie(
        this.loginForm.value.UserId,
        this.loginForm.value.Password,
        true
      );
    }

    if (Number(this.userCaptchaInput) !== this.correctAnswer) {
      this.toastService.showError('Captcha incorrect. Please try again!');
      this.generateNewCaptcha();
      return;
    }


    this.ngxUiLoaderService.start();

    this.currentLocation = setTimeout(() => {
      this.getAccurateLocation();
    }, 1000); 

    const loginPayload = {
      ...this.loginForm.value,
      Country: this.currentLocation?.country,
      City: this.currentLocation?.city,
      Area: this.currentLocation?.area,
      Latitude: this.currentLocation?.latitude,
      Longitude: this.currentLocation?.longitude
    };



    this.authService.login(loginPayload).subscribe({

      next: (response) => {
        this.ngxUiLoaderService.stop();

      
        if (response.status === 209 && response.data?.requireRoleSelection) {

          this.roleList = response.data.roles;
          this.showRoleSelector = true;

          const firstRole = this.roleList[0];


          const newPayload = {
            ...loginPayload,
            RoleId: firstRole.roleId
          };

          localStorage.setItem("roles", JSON.stringify(this.roleList));

          this.authService.login(newPayload).subscribe(res => {
            if (res.status === 200) {
              this.authService.storeUser(res.data);

              this.navigateByRole(res.data.roleId);
            } else {
              this.toastService.showError(res.message);
            }
          });

          return;
        }

        if (response.status === 200) {
          this.authService.storeUser(response.data);
          this.navigateByRole(response.data.roleId);
          return;
        }

        this.toastService.showError(response.message);
      },

      error: (err) => {
        this.ngxUiLoaderService.stop();
        // handle network/server errors here
         if (err.status === 401) {
          this.toastService.showError("Invalid UserId or Password");
        } else if (err.status === 429) {
          this.toastService.showError("Too many login attempts. Try again after 5 minutes");
        } else if (err.status === 400) {
          this.toastService.showError(err.error?.message || "Bad request");
        } else {
          this.toastService.showError("Server error. Please try again.");
        }
      }

    });
    
  }
  loginWithRole(payload: any, roleId: number) {

    const newPayload = {
      ...payload,
      RoleId: roleId
    };

    this.ngxUiLoaderService.start();

    this.authService.login(newPayload).subscribe({
      next: (res) => {
        this.ngxUiLoaderService.stop();

        if (res.status === 200) {
          this.handleLoginSuccess(res.data);
        } else {
          this.toastService.showError(res.message || 'Role login failed');
        }
      },
      error: () => {
        this.ngxUiLoaderService.stop();
        this.toastService.showError("Error while selecting role");
      }
    });
  }
  handleLoginSuccess(user: any) {
    this.authService.storeUser(user);
  
    this.navigateByRole(user.selectedRole);

  }




  private navigateByRole(roleId: number) {
    if (roleId === 1) {
      this.router.navigate(['/admin/AdminDash']);
    } else {
      this.router.navigate(['/dashboard']);
    }
  }


  getUserLocation(): Promise<any> {
    return new Promise((resolve) => {
      if (!navigator.geolocation) {
        resolve(null);
        return;
      }

      navigator.geolocation.getCurrentPosition(
        (position) => {
          resolve({
            latitude: position.coords.latitude,
            longitude: position.coords.longitude
          });
        },
        () => resolve(null),
        { timeout: 5000 }
      );
    });
  }
  getLocationFromIp(): Promise<any> {
    return fetch('https://ipapi.co/json/')
      .then(res => res.json())
      .then(data => ({
        area: null,
        city: data.city,
        state: data.region,
        country: data.country_name,
        locationName: `${data.city}, ${data.region}, ${data.country_name}`,
        latitude: data.latitude,
        longitude: data.longitude
      }))
      .catch(() => null);
  }


  async getAccurateLocation(): Promise<any> {
    const gpsCoords = await this.getUserLocation();

    if (gpsCoords) {
      const location = await this.reverseGeocode(
        gpsCoords.latitude,
        gpsCoords.longitude
      );
      if (location) return location;
    }

    return await this.getLocationFromIp();
  }


  async reverseGeocode(lat: number, lng: number) {
    const response = await fetch(
      `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=YOUR_API_KEY`
    );

    const data = await response.json();
    if (!data.results?.length) return null;

    const components = data.results[0].address_components;

    const getComponent = (type: string) =>
      components.find((c: any) => c.types.includes(type))?.long_name;

    return {
      area:
        getComponent('sublocality') ||
        getComponent('sublocality_level_1') ||
        getComponent('neighborhood') ||
        getComponent('route'),

      city: getComponent('locality'),

      state: getComponent('administrative_area_level_1'),
      country: getComponent('country'),

      locationName: data.results[0].formatted_address,

      latitude: lat,
      longitude: lng
    };
  }

  disablePaste(event: ClipboardEvent) {
    event.preventDefault();
    this.toastService.showError('Pasting is not allowed. Please type the captchdata manually.');
  }

  blockInput(event: KeyboardEvent) {
    event.preventDefault();
  }
  generateNewCaptcha() {
    const captcha = this.captchaService.generateCaptcha();
    this.captchaQuestion = captcha.question;
    this.correctAnswer = captcha.answer;
    this.userCaptchaInput = 0;
    this.errorMessage = '';
  }

  captchdata(event: any) {
    this.userCaptchaInput = event.target.value || 0;
  }





  showSuccess() {
    this.toastService.showSuccess('This is a success message!');
  }

  showError() {
    this.toastService.showError('This is an error message!');
  }

  showInfo() {
    this.toastService.showInfo('This is an info message!');
  }
  emailCookieKey = 'rememberedEmail';
  saveEmailInCookie(email: string, remember: boolean) {
    if (remember) {
      this.cookieService.set(this.emailCookieKey, email, 30);
    } else {
      this.cookieService.delete(this.emailCookieKey);
    }
  }
  userIdCookieKey = 'rememberedUserId';
  passwordCookieKey = 'rememberedPassword';

  saveUserIdInCookie(userId: string, password: string, remember: boolean) {
    if (remember) {
      this.cookieService.set(this.userIdCookieKey, userId, 30);
      this.cookieService.set(this.passwordCookieKey, password, 30);
    } else {
      this.cookieService.delete(this.userIdCookieKey);
      this.cookieService.delete(this.passwordCookieKey);
    }
  }

  getEmailFromCookie(): string | null {
    return this.cookieService.get(this.emailCookieKey) || null;
  }
  setEncryptedCookie(
    name: string,
    value: string,
    expireDays: number,
    key: any
  ) {
    const encrypted = CryptoJS.AES.encrypt(value, key).toString();
    this.cookieService.set(name, encrypted, expireDays);
  }
  getDecryptedCookie(name: string, key: any): string | null {
    const encrypted = this.cookieService.get(name);
    if (!encrypted) return null;

    try {
      const bytes = CryptoJS.AES.decrypt(encrypted, key);
      return bytes.toString(CryptoJS.enc.Utf8);
    } catch (e) {
      console.error('Decryption error', e);
      return null;
    }
  }



  // -----------------------------New design----------------

  // Theme & Language
  isDark = false;
  isEnglish = true;

  // Captcha
  captchaCode = '';

  // Translations
  translations = TRANSLATIONS_EN;



  // Theme Toggle
  toggleTheme(): void {
    this.isDark = !this.isDark;
    document.documentElement.classList.toggle('dark', this.isDark);


  }

  // Language Toggle
  toggleLanguage(): void {
    this.isEnglish = !this.isEnglish; // Toggle the language flag

    // Update translations based on the current language
    this.translations = this.isEnglish ? TRANSLATIONS_EN : TRANSLATIONS_HI;
  }


  // Password Visibility
  togglePassword(passwordInput: HTMLInputElement): void {
    passwordInput.type =
      passwordInput.type === 'password' ? 'text' : 'password';
  }

  // Refresh Captcha
  refreshCaptcha(): void {
    const chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    this.captchaCode = '';
    for (let i = 0; i < 4; i++) {
      this.captchaCode += chars.charAt(
        Math.floor(Math.random() * chars.length)
      );
    }
  }

  // Form Submit
  handleLogin(form: any): void {
    const enteredCaptcha = form.value.captcha;

    if (enteredCaptcha?.toUpperCase() !== this.captchaCode) {
      this.toastService.showError('Invalid Captcha Code!');
      this.refreshCaptcha();
      return;
    }

    this.toastService.showSuccess('Login Submitted Successfully (Mockup)');
  }
}
